import { render, staticRenderFns } from "./CatIntroduction.vue?vue&type=template&id=c608802c&"
import script from "./CatIntroduction.vue?vue&type=script&lang=js&"
export * from "./CatIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CatIntroduction.vue?vue&type=style&index=0&id=c608802c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports